import lodash from 'lodash'

const Plugin = {}

Plugin.install = function install (Vue) {
  Vue._ = lodash
  Vue.prototype._ = lodash
}

export default Plugin

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(Plugin)
}
